import fetchHelper from "./fetch-helper";

export default class WishlistHelper {
    static async create(force) {
        const data = this.getData();
        if (data) {
            if (force || !data.wishlistId || !data.shareCode) {
                await this.callAPI(data);
            }
            return data;
        }
    }

    static async callAPI(data) {
        const formData = new FormData();
        formData.set('data', JSON.stringify(data));
        try {
            const request = fetchHelper('/gateway/api/wishlist', { method: 'POST', body: formData });
            const response = await request;
            if (response.ok) {
                const result = await response.json();
                if (result.wishlistId) {
                    data.shareCode = result.shareCode;
                    data.wishlistId = result.wishlistId;
                    this.setData(data);
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    static getData() {
        let data = sessionStorage.getItem('ma2-checkout');
        try {
            return JSON.parse(data);
        } catch (err) {
            return null;
        }
    }

    static setData(data) {
        const json = JSON.stringify(data);
        sessionStorage.setItem('ma2-checkout', json);
    }

    static removeData() {
        sessionStorage.removeItem('ma2-checkout');
    }
}